import { ScopeContextStorage } from './scope-storage';

/**
 * Leave the signed-in flow for the login screen.
 *
 * Clearing the stored record first is what makes this an exit rather than a loop: Login
 * auto-resumes whenever getCurrentSessionId() still returns a pointer, so a bare
 * navigate('/login') is replace-navigated straight back into the flow the user was
 * trying to leave. A full document load then drops in-memory state with it, mirroring
 * the logout in UserMenu.
 */
export function exitToLogin(): void {
  ScopeContextStorage.clearScopeContext();
  window.location.href = '/login';
}
